import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { FixingDataImpl } from "../model/impl/FixingDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class FixingDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: FixingDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.bmOrderType != null) {
      this.baseEncoder.writeStartFid(910, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(910),
        false,
        encodable.bmOrderType,
        streamout,
      );
      this.baseEncoder.writeEndFid(910, streamout);
    }
    /*Object encoding*/
    if (encodable.revalStatus != null) {
      this.baseEncoder.writeStartFid(911, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(911),
        false,
        encodable.revalStatus,
        streamout,
      );
      this.baseEncoder.writeEndFid(911, streamout);
    }
    /*Object encoding*/
    if (encodable.stpTarget != null) {
      this.baseEncoder.writeStartFid(912, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(912),
        false,
        encodable.stpTarget,
        streamout,
      );
      this.baseEncoder.writeEndFid(912, streamout);
    }
    /*Object encoding*/
    if (encodable.traderVisibilityOffset != null) {
      this.baseEncoder.writeStartFid(913, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(913),
        false,
        encodable.traderVisibilityOffset,
        streamout,
      );
      this.baseEncoder.writeEndFid(913, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFixingDate != null) {
      this.baseEncoder.writeStartFid(914, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(914),
        false,
        encodable.reqFixingDate,
        streamout,
      );
      this.baseEncoder.writeEndFid(914, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFixingTime != null) {
      this.baseEncoder.writeStartFid(915, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(915),
        false,
        encodable.reqFixingTime,
        streamout,
      );
      this.baseEncoder.writeEndFid(915, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFixingTzCd != null) {
      this.baseEncoder.writeStartFid(916, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(916),
        false,
        encodable.reqFixingTzCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(916, streamout);
    }
    /*Object encoding*/
    if (encodable.reqFixingCd != null) {
      this.baseEncoder.writeStartFid(917, streamout);
      this.baseEncoder.writeObject(
        false,
        FixingDataImplEncoder.fidTypeMap.get(917),
        false,
        encodable.reqFixingCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(917, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,FixingDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [910, "com.bcdfx.model.BenchmarkOrderType"],
    [911, "com.bcdfx.model.RevaluationStatus"],
    [912, "java.lang.Boolean"],
    [913, "java.lang.Long"],
    [914, "java.lang.String"],
    [915, "java.lang.String"],
    [916, "java.lang.String"],
    [917, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: FixingDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 910: {
          /*Object encoding*/
          let val: CubiqTS.BenchmarkOrderType = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(910),
            streamin,
          );
          encodable.bmOrderType = <CubiqTS.BenchmarkOrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 911: {
          /*Object encoding*/
          let val: CubiqTS.RevaluationStatus = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(911),
            streamin,
          );
          encodable.revalStatus = <CubiqTS.RevaluationStatus>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 912: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(912),
            streamin,
          );
          encodable.stpTarget = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 913: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(913),
            streamin,
          );
          encodable.traderVisibilityOffset = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 914: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(914),
            streamin,
          );
          encodable.reqFixingDate = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 915: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(915),
            streamin,
          );
          encodable.reqFixingTime = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 916: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(916),
            streamin,
          );
          encodable.reqFixingTzCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 917: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FixingDataImplEncoder.fidTypeMap.get(917),
            streamin,
          );
          encodable.reqFixingCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,FixingDataImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return FixingDataImplEncoder.fidTypeMap.has(fid);
  }
}
